import { frontendURL } from '../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../featureFlags';
import {
  ATTENDANCE_PERMISSIONS,
  ASSIGNMENT_POLICY_PERMISSIONS,
  LEGACY_AGENT_ONLY_PERMISSIONS,
} from '../../../constants/permissions.js';

const workforceMyShiftPermissions = {
  anyOf: [
    'administrator',
    LEGACY_AGENT_ONLY_PERMISSIONS,
    ATTENDANCE_PERMISSIONS,
  ],
};

const workforceManagePermissions = {
  anyOf: [
    'administrator',
    LEGACY_AGENT_ONLY_PERMISSIONS,
    ASSIGNMENT_POLICY_PERMISSIONS,
    ATTENDANCE_PERMISSIONS,
  ],
};

const WorkforceLayout = () => import('./WorkforceLayout.vue');
const WorkforceSchedulesPage = () =>
  import('./pages/WorkforceSchedulesPage.vue');
const WorkforceAttendancePage = () =>
  import('./pages/WorkforceAttendancePage.vue');
const WorkforceLivePage = () => import('./pages/WorkforceLivePage.vue');
const WorkforceAssignmentPage = () =>
  import('./pages/WorkforceAssignmentPage.vue');
const WorkforceMyShiftPage = () => import('./pages/WorkforceMyShiftPage.vue');
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/workforce'),
      component: WorkforceLayout,
      children: [
        {
          path: '',
          redirect: to => ({ name: 'workforce_my_shift', params: to.params }),
        },
        {
          path: 'my-shift',
          name: 'workforce_my_shift',
          component: WorkforceMyShiftPage,
          meta: {
            featureFlag: FEATURE_FLAGS.WORKFORCE_MANAGEMENT,
            permissions: workforceMyShiftPermissions,
          },
        },
        {
          path: 'schedules',
          name: 'workforce_schedules',
          component: WorkforceSchedulesPage,
          meta: {
            featureFlag: FEATURE_FLAGS.WORKFORCE_MANAGEMENT,
            permissions: ['administrator', ASSIGNMENT_POLICY_PERMISSIONS],
          },
        },
        {
          path: 'assignment',
          name: 'workforce_assignment',
          component: WorkforceAssignmentPage,
          meta: {
            featureFlag: FEATURE_FLAGS.WORKFORCE_MANAGEMENT,
            permissions: ['administrator', ASSIGNMENT_POLICY_PERMISSIONS],
          },
        },
        {
          path: 'attendance',
          name: 'workforce_attendance',
          component: WorkforceAttendancePage,
          meta: {
            featureFlag: FEATURE_FLAGS.WORKFORCE_MANAGEMENT,
            permissions: ['administrator', ATTENDANCE_PERMISSIONS],
          },
        },
        {
          path: 'live',
          name: 'workforce_live',
          component: WorkforceLivePage,
          meta: {
            featureFlag: FEATURE_FLAGS.WORKFORCE_MANAGEMENT,
            permissions: ['administrator', ATTENDANCE_PERMISSIONS],
          },
        },
      ],
      meta: {
        featureFlag: FEATURE_FLAGS.WORKFORCE_MANAGEMENT,
        permissions: workforceManagePermissions,
      },
    },
  ],
};
